import { render } from "./professores.vue?vue&type=template&id=665fa6aa&scoped=true"
import script from "./professores.vue?vue&type=script&lang=js"
export * from "./professores.vue?vue&type=script&lang=js"

import "./professores.vue?vue&type=style&index=0&id=665fa6aa&lang=scss&scoped=true"
import "./professores.vue?vue&type=style&index=1&id=665fa6aa&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665fa6aa"]])

export default __exports__